import React from 'react'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='why-sell'>
      <p data-type='title'>Why Sell on Saatchi Art?</p>
      <p data-type='sub-title'>As the world's leading online gallery...</p>
      <div data-type='stat-grid'>
        <div data-type='stat-grid-row'>
          <div data-type='stat-grid-item'>
            <p data-type='top-row'>Artists Represented</p>
            <h4 data-type='bottom-row'>110+ Countries</h4>
          </div>
          <span data-type='stat-border' />
          <div data-type='stat-grid-item'>
            <p data-type='top-row'>Works Sold to Collectors in</p>
            <h4 data-type='bottom-row'>140+ Countries</h4>
          </div>
          <span data-type='stat-border' data-style='goes-horizontal' />
          <div data-type='stat-grid-item'>
            <h4 data-type='top-row'>~12M+</h4>
            <p data-type='bottom-row'>Monthly Page Views</p>
          </div>
          <span data-type='stat-border' />
          <div data-type='stat-grid-item'>
            <h4 data-type='top-row'>~2M+</h4>
            <p data-type='bottom-row'>Monthly Visits</p>
          </div>
          <span data-type='stat-border-reverse' />
          <div data-type='stat-grid-item'>
            <h4 data-type='top-row'>~2M+</h4>
            <p data-type='bottom-row'>Social Followers</p>
          </div>
          <span data-type='stat-border' data-style='goes-horizontal' />
          <div data-type='stat-grid-item' data-style='stretch'>
            <p data-type='top-row'>Printed Catalog Sent to</p>
            <h4 data-type='bottom-row'>1M+ Households</h4>
          </div>
          <span data-type='stat-border' data-style='goes-horizontal' />
          <div data-type='stat-grid-item' data-style='wrap'>
            <h5>14 International Shows & Fairs Annually Reaching 100K People</h5>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component